import axios from './../../libs/api.request'

export function add (data) {
  return axios.request({
    url: '/employee/add',
    method: 'post',
    data
  })
}

export function update (data) {
  return axios.request({
    url: '/employee/update',
    method: 'post',
    data
  })
}

export function queryEmployee (data) {
  return axios.request({
    url: '/employee/list',
    method: 'post',
    data
  })
}

export function operationByPath (path) {
  return axios.request({
    url: path,
    method: 'get'
  })
}

export function deleteByIds (data) {
  return axios.request({
    url: '/employee/deleteByIds',
    method: 'post',
    data
  })
}
export function importByUrl (data) {
  return axios.request({
    url: '/employee/import',
    method: 'post',
    data
  })
}

export function addGroup (data) {
  return axios.request({
    url: '/permission/group/add',
    method: 'post',
    data
  })
}

export function updateGroup (data) {
  return axios.request({
    url: '/permission/group/update',
    method: 'post',
    data
  })
}

export function queryPermissionGroup (data) {
  return axios.request({
    url: '/permission/group/query',
    method: 'post',
    data
  })
}

export function queryPermissionGroupMember (data) {
  return axios.request({
    url: '/permission/group/member',
    method: 'post',
    data
  })
}

export function addUserToGroup (data) {
  return axios.request({
    url: '/permission/group/member/add',
    method: 'post',
    data
  })
}

export function removeUserToGroup (data) {
  return axios.request({
    url: '/permission/group/member/remove',
    method: 'post',
    data
  })
}

export function deletePermissionGroupByIds (data) {
  return axios.request({
    url: '/permission/group/deleteByIds',
    method: 'post',
    data
  })
}

export function permissionMeta () {
  return axios.request({
    url: '/permission/meta',
    method: 'get'
  })
}

export function updatePermissionFunction (data) {
  return axios.request({
    url: '/permission/group/function/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/components/employee/employeeApi.js